import { createPlatformState, platformAction, platformGetters, platformMutations } from '~/helpers/store'

export default {
  state: () => createPlatformState(),
  actions: {
    async fetchRoomPromotions ({ commit, getters }, more = false) {
      let page = 1

      if (more) {
        if (!getters.isPageComplete) {
          page = getters.currentPage + 1
        } else {
          return
        }
      }

      await platformAction({
        client: this.$api.rooms.promotions,
        method: 'getAll',
        commit,
        logError: this.$logError,
        params: {
          page,
          perPage: 100
        },
        include: ['hotels', 'hotels.venue']
      })
    }
  },
  getters: {
    ...platformGetters,
    isPageComplete: (_, getters) => getters.totalPages <= getters.currentPage
  },
  mutations: {
    ...platformMutations
  }
}
